import { runAction } from "../client";

export interface MeasuresRequest
{
    SensorId: number;
    DivisionId: number;
    VehicleId: number;
}

export interface Measures
{
    Quantities: Quantity[];
    Units: Unit[];
}

export interface Quantity
{
    Id: Quantities;
    Name: string;
    Units: number[];
    RelativeLevels: boolean;
    IsUnitEditable: boolean;
    SelectedUnitId?: number;
}

export interface Unit
{
    Id: number;
    Name: string;
}

export enum Quantities
{
    SimpleQuantity = 1,
    Pressure = 2,
    Temperature = 3,
    Speed = 4
}

export interface GetMeasuresFn
{
    <K extends keyof MeasuresRequest>(request: Pick<MeasuresRequest, K>): Promise<Measures>;
}

export const getMeasures: GetMeasuresFn = <K extends keyof MeasuresRequest>(request: Pick<MeasuresRequest, K>) => {
    return runAction<Measures>('/action/GetMeasures', request);
}


// WEBPACK FOOTER //
// ./src/rest/Misc/measures.ts